import GoogleMap from "../utils/map";
import Form from "../utils/form";

const Contacts = {
  init() {
    this.events();
    this.renderMap();
  },

  events() {
    Form.init("#contact-form");

    $(".js-toggle").on("click", function () {
      const target = $(this).data("target");
      $(`[data-container=${target}]`).slideToggle();
    });
  },

  renderMap() {
    const mapEl = $("#map");

    if (!mapEl.length) {
      return;
    }

    const data = {
      lat: mapEl.data("lat"),
      lng: mapEl.data("lng"),
      zoom: mapEl.data("zoom"),
    };

    GoogleMap.create(data, mapEl);
  },
};

export default Contacts;
